export const tabsList = [
	'Thông tin cơ bản',
	'Thực hiện',
	'Báo cáo tiến độ',
	'Báo cáo tổng kết',
	'Kết quả',
	'Hồ sơ khác'
];
